/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

// Component imports
import VariablesList from '../VariablesList';

// Misc imports
import { useFetchEventIdInteractionVariablesQuery } from '../../../store/interactionMetadata/interactionMetadataApi';

const SessionInteractionVariablesTab = ({
  selectedChatSessionMessageId
}) => {

  const { orgId } = useParams();

  const { data: interactionVariables, isLoading: isLoadingInteractionVariables } = useFetchEventIdInteractionVariablesQuery({ orgId, eventId: selectedChatSessionMessageId }, { skip: !selectedChatSessionMessageId });

  return (
    <VariablesList maxHeight={590} variables={interactionVariables} isLoading={isLoadingInteractionVariables}/>
  );
};

SessionInteractionVariablesTab.propTypes = {
  selectedChatSessionMessageId: PropTypes.string
};

export default SessionInteractionVariablesTab;
